import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod/v4";
import { historyDetailQueryOptions } from "@/lib/queries/detector/history";

const provenanceSearchSchema = z.object({
  history_id: z.uuid().optional().catch(undefined),
});
export const Route = createFileRoute("/_app/_provenance")({
  validateSearch: provenanceSearchSchema,
  loaderDeps: ({ search: { history_id } }) => ({ history_id }),
  async loader({ context: { queryClient }, deps: { history_id } }) {
    if (history_id)
      await queryClient.ensureQueryData(historyDetailQueryOptions(history_id));
  },
});
